"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformRealtimeChannels = void 0;
const PLATFORM_CHANNEL_NAME = 'editor-platform-channel';
exports.PlatformRealtimeChannels = {
    ROUTER_REFRESH: {
        name: PLATFORM_CHANNEL_NAME,
        resourceId: 'router-refresh',
    },
};
